import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { RecipeList } from '../components/recipes/RecipeList';
import { Button } from '../components/ui/Button';
import { recipeApi } from '../services/api';
import styles from './RecipeListPage.module.css';

const RecipeListPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="login-message">
        <p>Please sign in to access your recipes</p>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div className={`${styles.titleBlock} mobile-page-title-anchor`}>
          <p className={styles.eyebrow}>Kitchen library</p>
          <h1 className={styles.title}>Recipes</h1>
          <p className={styles.subtitle}>
            Save imports, household staples, and weeknight ideas in one place.
          </p>
        </div>

        <div className={styles.headerActions}>
          <Button
            variant="primary"
            size="md"
            leftIcon={FaPlus({ 'aria-hidden': 'true' })}
            onClick={() => navigate('/recipes/new')}
          >
            Create New Recipe
          </Button>
        </div>
      </header>
      <RecipeList
        onRecipeClick={(recipe) => navigate(`/recipes/recipe/${recipe.id}`)}
        onRecipeEdit={(recipe) => navigate(`/recipes/recipe/${recipe.id}/edit`)}
        onRecipeDelete={(recipe) => recipeApi.delete(recipe.id)}
      />
    </div>
  );
};

export default RecipeListPage;
